import { useEffect, useState } from "react";
import { db } from "../lib/firebase";
import { doc, onSnapshot } from "firebase/firestore";

// `app_releases` es una colección raíz sin {env}: todos los ambientes leen el mismo doc.
// Solo lectura; la escribe markStableRelease (kiosk-functions) desde MD Operaciones.
export function useAppReleases(appIds, enabled = true) {
  const [loadedReleases, setLoadedReleases] = useState(false);
  const [releases, setReleases] = useState({});
  const key = appIds.join(",");

  useEffect(() => {
    if (!enabled) return;
    setLoadedReleases(false);
    const ids = key.split(",");
    const pending = new Set(ids);

    const unsubs = ids.map((id) => onSnapshot(doc(db, "app_releases", id), (snapshot) => {
      setReleases((prev) => ({ ...prev, [id]: snapshot.exists() ? snapshot.data() : null }));
      pending.delete(id);
      if (pending.size === 0) setLoadedReleases(true);
    }, (error) => {
      console.error(`[useAppReleases] Error reading app_releases/${id}:`, error);
      setReleases((prev) => ({ ...prev, [id]: null }));
      pending.delete(id);
      if (pending.size === 0) setLoadedReleases(true);
    }));

    return () => unsubs.forEach((unsub) => unsub());
  }, [key, enabled]);

  return {loadedReleases, releases};
}
